import React, { useState, } from "react";

const KS2SectionAKiwiSaver = (props) => {
  const { setKiviMember } = props;
  const [kiwiMember, setKiwiMember] = useState();

  const handleKiviMemberChange = (e) => {
    const value = e.target.value;
    setKiwiMember(value);
    setKiviMember(value);
  };

  return (
    <div className="row">
    <div className="col-sm-12 col-md-12 col-lg-12 mb-3 section-number-box">
      <div className="mb-3 number">1.</div>
      <div className="details">
        <div className="form-group form-inline">
          <div className="col-md-5 yes-no-label">
            <label>Are you a KiwiSaver member?</label>
          </div>
          <div className="section-form-group yes-no-box col-md-7">
            <div className="section-form-group-inline">
              <div className="form-check form-check-inline mb-1">
                <input
                    type="radio"
                    id="kivi_yes"
                    name="kiviMember"
                    value="yes"
                    checked={kiwiMember === "yes"}
                    onChange={handleKiviMemberChange}
                    //className="form-check-input"
                    style={{ transform: "scale(1.5)", marginRight: "8px" }}
                  />
                <label htmlFor="kivi_yes" className="form-check-label mb-0">Yes. Go to Question 2</label>
              </div>
            </div>
            <div className="section-form-group-inline">
              <div className="form-check form-check-inline mb-1">
                <input
                  type="radio"
                  id="kivi_no"
                  name="kiviMember"
                  value="no"
                  checked={kiwiMember === "no"}
                  onChange={handleKiviMemberChange}
                  //className="form-check-input"
                  style={{ transform: "scale(1.5)", marginRight: "8px" }}
                />
                <label htmlFor="kivi_no" className="form-check-label mb-0">No. Go to Question 4</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default KS2SectionAKiwiSaver;